var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('profile-data-component',{attrs:{"mode":"profile","userid":"-1"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }